import { Navigate, Outlet } from "react-router-dom";
import Loading from "../Loading";
import { useStaffAuthorization } from "./useStaffAuthorization";

/**
 * Route gate for the staff-only `/admin` surface
 * (s-admin-authz-shell-advice-019e9cbb). Mirrors `AdminDocsRoute`, but keyed
 * on the `Advice Cloud Staff` role rather than the firm-scoped `"Admin"`.
 *
 * Behaviour:
 *   - `loading`  → visible loading indicator from mount until resolution (R6).
 *   - `staff`    → render the gated children.
 *   - otherwise  → redirect to `/dashboard`. This covers `not-staff` AND the
 *     fail-closed `error` state (token error / timeout): a non-staff user
 *     renders 0 admin content (R5 / AC6a), and a stalled check redirects
 *     rather than hanging in loading (R8 / AC8).
 *
 * The server remains the source of truth; this gate is defense-in-depth.
 */
export default function StaffRoute() {
  const status = useStaffAuthorization();

  if (status === "loading") {
    return <Loading message="admin" />;
  }

  if (status !== "staff") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
